// src/layouts/visitMachine/strategies/resolveProfitPercentage.js

export function resolveProfitPercentage(machine, profitPercentages = [], isEditMode = false) {
  const percentages = Array.isArray(profitPercentages) ? profitPercentages : [];
  const historicalId =
    machine?.HistoricalProfitPercentage?.Id ?? machine?.LocalMachineProfitPercentageId ?? null;

  if (isEditMode && machine?.HistoricalProfitPercentage) {
    return {
      ...machine.HistoricalProfitPercentage,
      Id: historicalId,
    };
  }

  if (isEditMode && historicalId != null) {
    const historicalMatch = percentages.find(
      (percentage) => Number(percentage?.Id) === Number(historicalId)
    );
    if (historicalMatch) return historicalMatch;
  }

  const machineTypeId = machine?.MachineType?.Id ?? machine?.MachineTypeId;
  return (
    percentages.find((percentage) => Number(percentage?.MachineTypeId) === Number(machineTypeId)) ||
    {}
  );
}
